import type { ReactNode } from 'react';

export const symbol_camera_outdoor: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M510-210q-14 0-24.5-10.5T475-245v-170q0-14 10.5-24.5T510-450h175q14 0 24.5 10.5T720-415v55l58-33q7.59-5 14.79-.5Q800-389 800-380v100q0 8.61-7 13.3-7 4.7-15-.3l-58-33v55q0 14-10.5 24.5T685-210H510Zm-350 30v-390q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q15.68-12 35.84-12Q500-825 516-813l272 204q12.24 9 12.62 21 .38 12-6.42 21-6.79 9-18.5 12-11.7 3-23.7-6L480-765 220-570v390h550q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220q-24.75 0-42.37-17.63Q160-155.25 160-180Zm320-292Z"
		/>
	</svg>
);
